export const SIGNING_DOCUMENTS_PATH = "/document-registry";
